import React from "react";
import { withRouter } from "react-router-dom";
import "./App.css";

import Customer from "./routes/Customer";
import Public from "./routes/Public";

function App(props) {
	return (
		<>
			<Public {...props}/>
			<Customer {...props}/>
		</>
	);
}

export default withRouter(App);
